module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/ode/node_modules/axios/index.js
// module id = 8
// module chunks = 0